<template>
  <div class="consumer-checkout" v-if="orderItemDatas.length > 0">
    <h1>주문 / 결제</h1>
    <hr />
    <div class="delivery-info-container">
      <h2>배송지</h2>
      <div class="delivery-way-container">
        <div class="select-container">
          <div>
            <input
              type="radio"
              id="domestic"
              v-model="deliveryWay"
              value="domestic"
            />
            <label for="domestic">국내배송</label>
          </div>
          <div>
            <input
              type="radio"
              id="quick"
              v-model="deliveryWay"
              value="quick"
            />
            <label for="quick">카카오 T 퀵</label>
          </div>
          <div>
            <input
              type="radio"
              id="manual"
              v-model="deliveryWay"
              value="manual"
            />
            <label for="manual">직접수령</label>
          </div>
        </div>
        <div class="description-container">
          <div v-if="deliveryWay === 'domestic'">
            <p>CJ대한통운을 통해 발송되는 배송방법입니다.</p>
            <p>
              기본 배송료는 4,000원이며 원화 기준 5만원 이상 주문 시
              무료배송됩니다.
            </p>
            <p>제주 / 도서산간 지역은 구매 금액 상관없이 5,000원 추가됩니다.</p>
            <br />
            <p>배송 기간 : 결제 시점으로부터 영업일 기준 1 ~ 3일</p>
          </div>
          <div v-else-if="deliveryWay === 'quick'">
            <p>현재 대구 지역만 지원되니 꼭 확인 부탁드립니다.</p>
            <p>
              알림톡으로 퀵비 결제 링크가 발송됩니다. 링크를 통해 배송료 결제를
              추가로 진행해주세요.
            </p>
            <br />
            <p>배송 기간 : 결제 시점으로부터 영업일 기준 1 ~ 2일</p>
          </div>
          <div v-else>
            <p>네코쿠모 본점에서 직접 수령하는 방법입니다.</p>
            <p>상품 준비에는 당일 ~ 영업일 기준 2일 정도 걸리실 수 있으시며,</p>
            <p>상품이 준비되면 알림톡으로 연락드립니다.</p>
            <br />
            <p>픽업 가능일 : 결제 시점으로부터 영업일 기준 1 ~ 2일</p>
            <button @click="openMapPopup">지도보기</button>
          </div>
        </div>
      </div>
      <div class="address-container">
        <div>
          <div>
            <p>받는사람<span style="color: #007bff">*</span></p>
            <input type="text" v-model="consumerName" />
          </div>
          <div v-if="deliveryWay === 'domestic' || deliveryWay === 'quick'">
            <p>주소<span style="color: #007bff">*</span></p>
            <div>
              <div>
                <input
                  type="text"
                  disabled
                  placeholder="우편번호 (ex. 12345)"
                  v-model="consumerPostCode"
                />
                <button @click="openDaumPostcode">주소검색</button>
              </div>
              <input
                type="text"
                disabled
                placeholder="기본 주소"
                v-model="consumerAddress1"
              />
              <input
                type="text"
                placeholder="나머지 주소"
                v-model="consumerAddress2"
              />
            </div>
          </div>
          <div>
            <p>휴대전화<span style="color: #007bff">*</span></p>
            <input type="tel" v-model="consumerPhone" />
          </div>
          <input
            type="text"
            placeholder="배송 메시지를 입력해주세요."
            v-model="consumerDeliveryMessage"
          />
          <div>
            <div class="save-container">
              <input
                type="checkbox"
                id="addressSave"
                v-model="consumerAddressSave"
              />
              <label for="addressSave">
                이 주소를 저장하고 다음 주문에도 사용합니다.
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr />
    <div class="order-items-container">
      <h2>주문 상품</h2>
      <div class="item-container">
        <div v-for="item in orderItemDatas" :key="item.id">
          <img :src="item.productThumbnailUrl.originalUrl" />
          <div>
            <p class="product-name">{{ item.productName }}</p>
            <p class="option-name">옵션: {{ item.optionName }}</p>
            <p class="option-count">수량: {{ item.count }}개</p>
            <p class="option-price">
              {{
                paymentMethod === "bank"
                  ? `${(
                      item.productBankSellPrice * item.count
                    ).toLocaleString()}원`
                  : `${(item.productSellPrice * item.count).toLocaleString()}원`
              }}
            </p>
          </div>
        </div>
      </div>
      <div class="fee-container">
        <p class="title">배송비</p>
        <p class="content">{{ deliveryFee.toLocaleString() }}원</p>
      </div>
    </div>
    <hr />
    <div class="payment-method-container">
      <h2>결제수단</h2>
      <div class="input-container">
        <div
          @click="paymentMethod = 'bank'"
          :class="paymentMethod === 'bank' ? 'active' : ''"
        >
          <input
            type="radio"
            id="bank"
            v-model="paymentMethod"
            value="bank"
            style="display: none"
          />
          <label for="bank">무통장입금</label>
        </div>
        <div
          @click="paymentMethod = 'card'"
          :class="paymentMethod === 'card' ? 'active' : ''"
        >
          <input
            type="radio"
            id="card"
            v-model="paymentMethod"
            value="card"
            style="display: none"
          />
          <label for="card">신용카드</label>
        </div>
      </div>
      <div class="desc-container" v-if="paymentMethod === 'bank'">
        <div>
          <p>입금은행<span>*</span></p>
          <input type="text" disabled value="토스뱅크 1002-2582-0340 김원재" />
        </div>
        <div>
          <p>입금자명<span>*</span></p>
          <input type="text" v-model="bankName" />
        </div>
      </div>
      <div class="desc-container" v-else>
        <div>
          <p>카드번호<span>*</span></p>
          <input
            type="text"
            maxlength="16"
            placeholder="숫자만 입력 (- 제외)"
            v-model="consumerCardNumber"
          />
        </div>
        <div>
          <p>유효기간<span>*</span></p>
          <input
            type="month"
            v-model="consumerCardValidDate"
            @change="checkCard"
          />
        </div>
        <div>
          <input type="checkbox" id="cardSave" v-model="consumercardSave" />
          <label for="cardSave">
            이 카드를 저장하고 다음 결제에도 사용합니다.
          </label>
        </div>
        <p>
          <span>결제하기 버튼</span>을 누르시면,
          <span>영업시간 내에 카드 키인 결제</span>가 진행됩니다.
        </p>
        <p>
          <span>카드 정보가 올바르지 않거나</span> 고액 결제로 인해 CVC 등
          <span>수동 승인이 필요할 경우</span>, 영업시간 내에 담당자가 통화
          요청을 진행할 수 있습니다.
        </p>
      </div>
    </div>
    <hr />
    <h2>적립금</h2>
    <div class="point-container">
      <div v-if="userData">
        <p class="title">예상 적립금</p>
        <input
          type="text"
          disabled
          :value="`${convertUserGradeCodeToPoint(
            userData.userGrade,
            paymentMethod.value === 'bank' ? totalBankPrice : totalCardPrice
          ).toLocaleString()} 냥코인`"
        />
      </div>
    </div>
    <p>적립금으로는 쇼핑몰 내에 판매중인 굿즈를 구매할 수 있습니다.</p>
    <hr />
    <button @click="checkout" v-if="paymentMethod === 'bank'">
      {{
        `${(
          totalBankPrice + (typeof deliveryFee === "string" ? 0 : deliveryFee)
        ).toLocaleString()}원`
      }}
      결제하기
    </button>
    <button @click="checkout" v-else>
      {{
        `${(
          totalCardPrice + (typeof deliveryFee === "string" ? 0 : deliveryFee)
        ).toLocaleString()}원`
      }}
      결제하기
    </button>
  </div>
</template>

<script setup lang="js">
import { computed, nextTick, onMounted, ref } from "vue";
import { db } from "@/lib/firebase";
import {
  getDoc,
  doc,
  setDoc,
  Timestamp,
  updateDoc,
  getDocs,
  query,
  collection,
  where,
  orderBy,
  limit,
} from "firebase/firestore";
import { sendPpurioMessage } from "@/lib/ppurio";
import router from "@/router";
import { getUserId } from "@/lib/auth";
import { convertUserGradeCodeToPoint } from "@/lib/utils";
import { useBusyLock } from "@/lib/useBusyLock";

const { runLocked } = useBusyLock();

const orderItemDatas = ref([]);
const recentPointData = ref(null);
const userData = ref(null);

const deliveryWay = ref("domestic");
const paymentMethod = ref("bank");

const consumerName = ref("");
const consumerPostCode = ref("");
const consumerAddress1 = ref("");
const consumerAddress2 = ref("");
const consumerPhone = ref("");
const consumerDeliveryMessage = ref("");
const consumerAddressSave = ref(false);

const consumerCardNumber = ref("");
const consumerCardValidDate = ref("");
const consumercardSave = ref(false);

const bankName = ref("");

// --- 결제수단별 상품 합계 (배송비 제외)
const totalBankPrice = computed(() =>
  orderItemDatas.value.reduce(
    (sum, item) => sum + Number(item.productBankSellPrice || 0) * Number(item.count || 0),
    0
  )
);

const totalCardPrice = computed(() =>
  orderItemDatas.value.reduce(
    (sum, item) => sum + Number(item.productSellPrice || 0) * Number(item.count || 0),
    0
  )
);

// --- 현재 결제수단 기준 상품 합계
const currentProductsPrice = computed(() => {
  return paymentMethod.value === "card" ? totalCardPrice.value : totalBankPrice.value;
});

// --- 배송비 계산
const deliveryFee = computed(() => {
  if (deliveryWay.value !== "domestic") return 0;
  return currentProductsPrice.value < 50000 ? 4000 : 0;
});

// --- 총 결제금액
const currentTotalPrice = computed(() => currentProductsPrice.value + deliveryFee.value);

// --- 주소 검색
function openDaumPostcode() {
  if (!window?.daum?.Postcode) {
    alert("주소 검색 스크립트가 아직 로드되지 않았습니다. 잠시 후 다시 시도해주세요.");
    return;
  }

  new window.daum.Postcode({
    oncomplete: (data) => {
      // --- 기본 주소
      let extraAddr = "";

      // --- 참고항목 조합 (도로명 주소일 때)
      if (data.addressType === "R") {
        if (data.bname) extraAddr += data.bname;
        if (data.buildingName) {
          extraAddr += extraAddr ? `, ${data.buildingName}` : data.buildingName;
        }
      }

      consumerPostCode.value = data.zonecode;
      consumerAddress1.value = data.address;
      consumerAddress2.value = extraAddr ? `(${extraAddr}) ` : "";

      nextTick(() => {
        document.querySelector('input[placeholder="나머지 주소"]')?.focus();
      });
    },
  }).open();
}

// --- 주문번호 생성
function generateOrderId(date = new Date()) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hour = String(date.getHours()).padStart(2, "0");
  const minute = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  const randomPart = [...Array(6)]
    .map(() => chars[Math.floor(Math.random() * chars.length)])
    .join("");

  return `${year}${month}${day}_${hour}${minute}${seconds}_${randomPart}`;
}

// --- 필수 입력 검증
function validateCheckoutForm() {
  if (
    consumerName.value === "" ||
    consumerPostCode.value === "" ||
    consumerAddress1.value === "" ||
    consumerPhone.value === ""
  ) {
    alert("필수 정보를 입력해주세요!");
    return false;
  }

  if (!orderItemDatas.value.length) {
    alert("주문할 상품이 없습니다.");
    return false;
  }

  if (paymentMethod.value === "bank" && bankName.value.trim() === "") {
    alert("입금자명을 입력해주세요!");
    return false;
  }

  if (paymentMethod.value === "card" && consumerCardNumber.value.trim() === "") {
    alert("카드 번호를 입력해주세요!");
    return false;
  }

  if (paymentMethod.value === "card" && consumerCardValidDate.value.trim() === "") {
    alert("카드 유효기간을 입력해주세요!");
    return;
  }

  return true;
}

// --- 주문 상품(productOrder) 문서 생성 데이터
function buildProductOrderPayload({
  item,
  orderId,
  productOrderId,
  uid,
  nowTs,
  userGrade,
  salespersonId,
  payMethod,
}) {
  const pricePerUnit =
    payMethod === "card"
      ? Number(item.productSellPrice || 0)
      : Number(item.productBankSellPrice || 0);

  const linePrice = pricePerUnit * Number(item.count || 0);

  return {
    orderId,
    productOrderId,
    productId: item.id,
    productName: item.productName,
    optionName: item.optionName,
    count: Number(item.count || 0),
    productPrice: linePrice,
    userId: uid,
    createdAt: nowTs,

    deliveryTrackingNumber: "",
    deliveryTrackingLink: "",
    deliveryCompany: "",

    pointAmount: convertUserGradeCodeToPoint(userGrade, linePrice),
    pointGived: false,

    claimType: "",
    claimReason: "",
    claimStatus: "",
    claimRequestedAt: null,
    claimProcessedAt: null,

    returnTrackingNumber: "",
    returnTrackingLink: "",
    returnCompany: "",
    returnStatus: "",
    returnReceivedAt: null,

    status: "BEFORE_PAYMENT",
    orderChannel: "NECOKUMO",
    salespersonId: salespersonId || "",
  };
}

// --- 공통 주문 처리 (bank/card 통합)
const checkout = () =>
  runLocked(async () => {
    if (!validateCheckoutForm()) return;

    const uid = getUserId();
    const now = new Date();
    const nowTs = Timestamp.fromDate(now);
    const orderId = generateOrderId(now);

    // --- 유저 정보 1회 조회
    const userSnap = await getDoc(doc(db, "users", uid));
    if (!userSnap.exists()) {
      alert("회원 정보를 찾을 수 없습니다.");
      return;
    }
    const tempUserData = userSnap.data();

    const productOrders = [];

    // --- productOrder 문서 병렬 생성 (forEach async 금지)
    await Promise.all(
      orderItemDatas.value.map(async (item, index) => {
        const padIndex = String(index).padStart(2, "0");
        const productOrderId = `${orderId}_${padIndex}`;
        productOrders.push(productOrderId);

        const payload = buildProductOrderPayload({
          item,
          orderId,
          productOrderId,
          uid,
          nowTs,
          userGrade: tempUserData.userGrade,
          salespersonId: tempUserData.userSalespersonCode,
          payMethod: paymentMethod.value,
        });

        await setDoc(doc(db, "productOrder", productOrderId), payload);
      })
    );

    // --- order 문서 생성
    await setDoc(doc(db, "order", orderId), {
      orderId,
      productOrders,
      createdAt: nowTs,
      deliveryFee: deliveryFee.value,
      paymentMethod: paymentMethod.value,

      // --- 무통장일 때만 bankName 저장
      bankName: paymentMethod.value === "bank" ? bankName.value : "",

      postCode: consumerPostCode.value,
      address1: consumerAddress1.value,
      address2: consumerAddress2.value,
      phone: consumerPhone.value,
      deliveryMessage: consumerDeliveryMessage.value,

      productsPrice: currentProductsPrice.value,
      totalPrice: currentTotalPrice.value,

      name: consumerName.value,
      deliveryWay: deliveryWay.value,
      userId: uid,
      orderChannel: "NECOKUMO",

      updatedAt: null,
      memoContent: "",
      cashReceiptNumber: "",
      cardReceiptNumber: "",

      // --- 카드 결제 정보 저장 (필요 시)
      cardNumber: paymentMethod.value === "card" ? consumerCardNumber.value || "" : "",
      cardValidDate:
        paymentMethod.value === "card" ? consumerCardValidDate.value || "" : "",

      salespersonId: tempUserData.userSalespersonCode || "",
    });

    // --- 사용자 기본 배송지 저장 옵션
    const userUpdatePayload = {};
    if (consumerAddressSave.value) {
      userUpdatePayload.userPostCode = consumerPostCode.value;
      userUpdatePayload.userAddress1 = consumerAddress1.value;
      userUpdatePayload.userAddress2 = consumerAddress2.value;
    }

    // --- 사용자 카드 정보 저장 옵션
    if (consumercardSave.value) {
      userUpdatePayload.userCardNumber = consumerCardNumber.value;
      userUpdatePayload.userCardValidDate = consumerCardValidDate.value;
    }

    if (Object.keys(userUpdatePayload).length > 0) {
      await updateDoc(doc(db, "users", uid), userUpdatePayload);
    }

    // --- 문자 발송 (고객)
    if (paymentMethod.value === "bank") {
      await sendPpurioMessage({
        targets: [{ to: consumerPhone.value }],
        targetCount: 1,
        content: `[네코쿠모] 주문이 완료되었습니다.\n아래 계좌로 입금해 주세요.\n\n주문번호: ${orderId}\n입금은행: 토스뱅크\n계좌번호: 1002-2582-0340\n예금주: 김원재\n결제금액: ${currentTotalPrice.value.toLocaleString()}원\n\n입금 확인 후 발송됩니다. 감사합니다!`,
        refKey: `ORDER_${orderId}`,
      });
    } else {
      await sendPpurioMessage({
        targets: [{ to: consumerPhone.value }],
        targetCount: 1,
        content: `[네코쿠모] 주문이 완료되었습니다.\n문자로 결제요청이 도착하면 결제 부탁드리겠습니다.\n\n주문번호: ${orderId}\n결제금액: ${currentTotalPrice.value.toLocaleString()}원\n\n결제 확인 후 발송됩니다. 감사합니다!`,
        refKey: `ORD_${orderId}`,
      });
    }

    // --- 관리자 문자 발송 (공통)
    await sendPpurioMessage({
      targets: [{ to: "01055779069" }],
      targetCount: 1,
      content: `[네코쿠모] 신규 주문 건이 있습니다.\n관리자 페이지에서 확인 부탁드립니다.\n\n주문번호: ${orderId}\n결제수단: ${
        paymentMethod.value === "bank" ? "무통장입금" : "신용카드"
      }\n결제금액: ${currentTotalPrice.value.toLocaleString()}원`,
      refKey: `ORDER_ADMIN_${orderId}`,
    });

    // --- 장바구니 주문이면 장바구니 정리
    // --- 현재는 전체 비우기 유지 (원하면 "주문한 항목만 제거" 버전으로 바꿔줄 수 있음)
    if (history.state?.query === "cart") {
      await updateDoc(doc(db, "users", uid), {
        userProductCartList: [],
      });
    }

    router.push({
      path: "/order-complete",
      state: { orderId },
    });
  }).catch((error) => {
    console.error("Checkout Error:", error);
    alert("주문 처리 중 오류가 발생했습니다.");
  });

// --- 지도 팝업
function openMapPopup() {
  window.open("https://map.naver.com/p/entry/place/2027661166");
}

// --- 주문 아이템(상품) 조회
async function fetchOrderItemDatas(orderItems) {
  try {
    const results = await Promise.all(
      orderItems.map(async (item) => {
        const productSnap = await getDoc(doc(db, "product", item.productCode));
        if (!productSnap.exists()) return null;

        return {
          id: productSnap.id,
          ...productSnap.data(),
          optionName: item.optionName,
          count: Number(item.count || 0),
        };
      })
    );

    orderItemDatas.value = results.filter(Boolean);
  } catch (error) {
    console.error("Failed to fetch product data:", error);
    throw error;
  }
}

// --- 최근 포인트 조회
async function fetchRecentPointData() {
  try {
    const userId = getUserId();
    const pointSnap = await getDocs(
      query(
        collection(db, "userPoints"),
        where("userId", "==", userId),
        orderBy("createdAt", "desc"),
        limit(1)
      )
    );

    recentPointData.value = pointSnap.docs[0]?.data() ?? null;
  } catch (error) {
    console.error("Failed to fetch user point data:", error);
    throw error;
  }
}

// --- 사용자 조회
async function fetchUserData() {
  try {
    const userId = getUserId();
    const userSnap = await getDoc(doc(db, "users", userId));

    if (!userSnap.exists()) {
      userData.value = null;
      throw new Error("사용자 정보를 찾을 수 없습니다.");
    }

    userData.value = userSnap.data();
  } catch (error) {
    console.error("Failed to fetch user data:", error);
    throw error;
  }
}

// --- 초기값 세팅
function fillConsumerFormFromUser(user) {
  consumerName.value = user.userName || "";
  consumerPostCode.value = user.userPostCode || "";
  consumerAddress1.value = user.userAddress1 || "";
  consumerAddress2.value = user.userAddress2 || "";
  consumerPhone.value = user.userPhone || "";

  // --- 필드명 통일 (기존 코드 버그 수정)
  consumerCardNumber.value = user.userCardNumber || "";
  consumerCardValidDate.value = user.userCardValidDate || "";
}

// --- 초기 로딩
onMounted(() => {
  runLocked(async () => {
    const orderItems = history.state?.orderItems;

    if (!orderItems || !Array.isArray(orderItems) || orderItems.length === 0) {
      console.warn("주문 데이터가 없습니다.");
      router.replace("/");
      return;
    }

    await fetchUserData();
    await Promise.all([
      fetchOrderItemDatas(orderItems),
      fetchRecentPointData(),
    ]);

    if (userData.value) {
      fillConsumerFormFromUser(userData.value);
    }
  }).catch((error) => {
    console.error("Failed to initialize checkout page:", error);
    alert("주문 페이지 정보를 불러오지 못했습니다.");
    router.replace("/");
  });
});
</script>

<style lang="scss" scoped>
.consumer-checkout {
  padding: 36px 24px;
  margin: auto;
  max-width: 1200px;

  > h1 {
    text-align: center;
  }

  hr {
    margin: 48px 0;
    border: none;
    border-bottom: 1px solid #efefef;
  }

  > .delivery-info-container {
    > .delivery-way-container {
      margin-top: 16px;
      > .select-container {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 16px;
        > div {
          display: flex;
          align-items: center;
          gap: 6px;
          > input {
            width: 20px;
            height: 20px;
          }
          > label {
            font-size: 18px;
          }
        }
      }

      > .description-container {
        margin-top: 16px;
        p {
          font-size: 16px;
          line-height: 24px;
        }

        button {
          background: black;
          color: white;
          font-size: 16px;
          cursor: pointer;
          border: none;
          padding: 8px 16px;
          border-radius: 4px;
          font-weight: 700;
          margin-top: 4px;
        }

        .app-link-container {
          display: flex;
          align-items: center;
          gap: 8px;
          margin-top: 8px;
          > a {
            height: 48px;
            > img {
              height: 48px;
            }
          }
        }
      }
    }

    > .address-container {
      margin-top: 24px;
      > div {
        > div {
          display: flex;
          gap: 16px;

          &:not(:first-child) {
            margin-top: 16px;
          }
          > p {
            width: 96px;
            line-height: 38px;

            > span {
              margin-left: 4px;
            }
          }

          > div {
            width: 100%;

            > div {
              display: flex;
              align-items: center;
              gap: 8px;
              > input {
                width: 100%;
                padding: 8px 12px;
                border: 1px solid #efefef;
                width: 100%;
                font-size: 16px;
                border-radius: 4px;
              }

              > button {
                width: 96px;
                height: 38px;
                background: black;
                color: white;
                font-size: 16px;
                cursor: pointer;
                border: none;
                border-radius: 4px;
                font-weight: 700;
              }
            }

            > input {
              width: 100%;
              padding: 8px 12px;
              border: 1px solid #efefef;
              width: 100%;
              font-size: 16px;
              border-radius: 4px;
              &:not(:first-child) {
                margin-top: 16px;
              }
            }
          }

          > input {
            padding: 8px 12px;
            border: 1px solid #efefef;
            width: 100%;
            font-size: 16px;
            border-radius: 4px;
          }

          > .save-container {
            display: flex;
            align-items: center;
            gap: 16px;

            > input {
              width: fit-content;
            }
          }
        }

        > input {
          margin-top: 24px;
          padding: 8px 12px;
          border: 1px solid #efefef;
          width: 100%;
          font-size: 16px;
          border-radius: 4px;
        }
      }
    }
  }

  > .order-items-container {
    > .item-container {
      margin-top: 24px;
      > div {
        display: flex;
        gap: 16px;

        &:not(:first-child) {
          margin-top: 16px;
        }

        > img {
          width: 128px;
        }

        > div {
          > .product-name {
            font-weight: 700;
            font-size: 20px;
          }

          > .option-name {
            font-size: 18px;
            margin-top: 8px;
          }

          > .option-count {
            font-size: 16px;
            margin-top: 4px;
          }

          > .option-price {
            font-size: 18px;
            font-weight: 700;
            margin-top: 8px;
          }
        }
      }
    }

    > .fee-container {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 24px;
      background-color: #efefef;
      border-radius: 4px;
      padding: 12px 16px;

      > .title {
        font-size: 16px;
        color: #666;
      }

      > .content {
        font-size: 18px;
        font-weight: 700;
      }
    }
  }

  > .payment-method-container {
    > .input-container {
      margin-top: 24px;
      > div {
        border: 1px solid #efefef;
        padding: 16px;
        cursor: pointer;
        > label {
          cursor: pointer;
        }

        &.active {
          border-color: #007bff;
          > label {
            color: #007bff;
            font-weight: 700;
          }
        }
      }
    }

    > .desc-container {
      padding: 12px 16px;
      background-color: #efefef;
      margin-top: 16px;
      border-radius: 4px;
      display: flex;
      flex-direction: column;
      gap: 12px;

      > div {
        display: flex;
        align-items: center;
        gap: 16px;

        > p {
          width: 96px;
          line-height: 38px;

          > span {
            margin-left: 4px;
            color: #007bff;
            font-weight: 700;
          }
        }

        > input {
          width: 100%;
          padding: 8px 12px;
          border: 1px solid black;
          font-size: 16px;
          border-radius: 4px;

          &[type="checkbox"] {
            width: fit-content;
          }
        }
      }

      > p {
        &:nth-child(4) {
          margin-top: 16px;
        }

        > span {
          color: #007bff;
          font-weight: 700;
        }
      }
    }
  }

  > .point-container {
    padding: 12px 16px;
    background-color: #efefef;
    margin-top: 24px;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    gap: 12px;

    > div {
      display: flex;
      align-items: center;
      gap: 16px;

      > .title {
        width: 96px;
        line-height: 38px;
      }

      > input {
        width: 100%;
        padding: 8px 12px;
        border: 1px solid black;
        font-size: 16px;
        border-radius: 4px;
      }

      > div {
        flex: 1;
      }
    }
  }

  > button {
    background: black;
    width: 100%;
    border: none;
    cursor: pointer;
    color: white;
    font-weight: 700;
    font-size: 18px;
    border-radius: 4px;
    height: 48px;
  }
}
</style>
